<template>
  <div>
    <div class="desktop">
      <section class="spec-hero">
        <span>Switcher의 기술사양</span>
      </section>
      <section class="specs-detail">
        <div class="spec">
          <div class="spec-title">
            <span>구성</span>
          </div>
          <div class="spec-description">
            <div class="img-container">
              <img src="@/assets/switcher/spec-detail-switcher.png" alt>
              <p class="name">스위처</p>
            </div>
            <div class="img-container mid-img">
              <img src="@/assets/switcher/spec-detail-velcro.png" alt>
              <p class="name">투명 벨크로</p>
            </div>
            <div class="img-container">
              <img src="@/assets/switcher/spec-detail-pin.png" alt>
              <p class="name">전원용 핀셋</p>
            </div>
          </div>
        </div>
        <div class="spec">
          <div class="spec-title">
            <span>크기 및 무게</span>
          </div>
          <div class="spec-description dimension">
            <div>
              <span class="dimension-title">크기</span>
              <div class="dimension-description">
                <p>가로: 7.4cm</p>
                <p>세로: 13.3cm</p>
                <p>두께: 2.5cm</p>
              </div>
            </div>
            <div style="vertical-align: top;">
              <span class="dimension-title">무게</span>
              <div class="dimension-description">
                <p>1버튼: 106g</p>
                <p>2버튼: 126g</p>
              </div>
            </div>
          </div>
        </div>
        <div class="spec">
          <div class="spec-title">
            <span>색상</span>
          </div>
          <div class="spec-description">
            <p>무광 화이트 & 그레이</p>
          </div>
        </div>
        <div class="spec">
          <div class="spec-title">
            <span>지원 기기</span>
          </div>
          <div class="spec-description">
            <p>iOS,Android</p>
            <p>*해외 안드로이드폰의 경우 호환이 어려울 수 있습니다.</p>
          </div>
        </div>
        <div class="spec">
          <div class="spec-title">
            <span>연결</span>
          </div>
          <div class="spec-description">
            <p>Bluetooth 4.0</p>
            <p>통신반경 30M</p>
          </div>
        </div>
        <div class="spec" style="margin-bottom: 90px;">
          <div class="spec-title">
            <span>충전</span>
          </div>
          <div class="spec-description">
            <p>3시간 완충, 40일 사용가능</p>
            <p>*Android 5pin 케이블</p>
          </div>
        </div>
      </section>
    </div>
    <div class="mobile">
      <section class="m-spec-hero">
        <h1>Switcher</h1>
        <p>Switcher의 기술사양</p>
      </section>
      <section class="m-specs-detail">
        <div class="m-spec">
          <p class="m-spec-title">구성</p>
          <div class="m-spec-description">
            <div class="img-container">
              <img
                style="width: 85px; height: 153px;"
                src="@/assets/switcher/m-spec-detail-switcher.png"
                alt
              >
              <p class="name">스위처</p>
            </div>
            <div class="img-container m-mid-img">
              <img
                style="width: 42px; height: 76px;"
                src="@/assets/switcher/m-spec-detail-velcro.png"
                alt
              >
              <p class="name">투명 벨크로</p>
            </div>
            <div class="img-container">
              <img
                style="width: 10px; height: 42px;"
                src="@/assets/switcher/m-spec-detail-pin.png"
                alt
              >
              <p class="name">전원용 핀셋</p>
            </div>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">크기 및 무게</p>
          <div class="m-spec-description">
            <div>
              <p>크기</p>
              <p style="margin-top: 8px">가로: 7.4cm</p>
              <p>세로: 13.3cm</p>
              <p>두께: 2.5cm</p>
            </div>
            <div style="vertical-align: top; margin-left: 40px;">
              <p>무게</p>
              <p style="margin-top: 8px">1버튼: 106g</p>
              <p>2버튼: 126g</p>
            </div>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">색상</p>
          <div class="m-spec-description">
            <p>무광 화이트 & 그레이</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">지원 기기</p>
          <div class="m-spec-description">
            <p>iOS, Android</p>
            <p>*해외 안드로이드폰의 경우 호환이 어려울 수 있습니다.</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">연결</p>
          <div class="m-spec-description">
            <p>Bluetooth 4.0</p>
            <p>통신반경 30M</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">충전</p>
          <div class="m-spec-description">
            <p>3시간 완충, 40일 사용 가능</p>
            <p>*Android 5pin 케이블</p>
          </div>
        </div>
      </section>
      <switcher-faq></switcher-faq>
    </div>
  </div>
</template>
<script>
import SwitcherFaq from './SwitcherFaq'
export default {
  name: 'switcher-spec',
  components: { SwitcherFaq },
  data () {
    return {
      isFirstDropdownOpen: false,
      isSecondDropdownOpen: false,
      isThirdDropdownOpen: false,
      isFourthDropdownOpen: false,
      isFifthDropdownOpen: false
    }
  },
  methods: {
    toggle: function (division) {
      switch (division) {
        case 1:
          this.isFirstDropdownOpen = !this.isFirstDropdownOpen
          break
        case 2:
          this.isSecondDropdownOpen = !this.isSecondDropdownOpen
          break
        case 3:
          this.isThirdDropdownOpen = !this.isThirdDropdownOpen
          break
        case 4:
          this.isFourthDropdownOpen = !this.isFourthDropdownOpen
          break
        case 5:
          this.isFifthDropdownOpen = !this.isFifthDropdownOpen
          break
      }
    }
  }

}
</script>
<style scoped>
.spec-hero {
  background: url("../../../assets/switcher/switcher-spec-hero.png") no-repeat
    center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}
.spec-hero span {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10%;
}
.spec {
  display: flex;
  justify-content: center;
  margin-top: 90px;
}
.spec .spec-title {
  vertical-align: top;
  font-size: 24px;
  width: 15%;
  text-align: left;
  font-weight: 500;
}
.spec-description {
  display: inline-block;
  width: 40%;
  margin-left: 70px;
  text-align: left;
  font-weight: 400;
}
.spec-description div {
  display: inline-block;
}
.mid-img {
  margin-left: 90px;
  margin-right: 90px;
}
.m-mid-img {
  margin-left: 20px;
  margin-right: 20px;
}
.spec-description img {
  vertical-align: bottom;
}

.name {
  margin-top: 10px !important;
}
.spec-description p {
  font-size: 16px;
  font-weight: 400;
  color: #3d4953;
  margin: 0;
}
.dimension {
  display: inline-flex;
  justify-content: space-between;
}

.dimension-title {
  vertical-align: top;
}
.dimension-description {
  margin-left: 50px;
  text-align: left;
}
.img-container {
  text-align: center;
}
.m-spec-hero {
  background: url("../../../assets/switcher/m-switcher-spec-hero.png") no-repeat center center;
  background-size: cover;
  min-height: 449px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}
.m-spec-hero h1 {
  font-size: 18px;
  font-weight: bold;
}
.m-spec-hero p {
  margin: 23px 0px 0px 0px;
  font-size: 18px;
}
.m-specs-detail {
  padding: 0px 0px 90px 26px;
}
.m-spec {
  text-align: left;
  margin-top: 67px;
}
.m-spec .m-spec-title {
  font-size: 18px;
}
.m-spec-description {
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0;
  color: #3d4953;
}
.m-spec-description div {
  display: inline-block;
}
.m-spec-description p {
  margin: 0;
}

.m-spec-description img {
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/products/switcher/SwitcherSpec.vue